import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../app/hooks";
import {
  fetchCitiesAndCounties,
  selectCitiesStatus,
  selectCityOptions,
} from "../../../../../app/appSlice";
import { CityAndCounty } from "../../../../types/apiTypes";

type Props = {
  allLabel?: string;
  groupByCounty?: boolean;
};

export const cityId = (c: CityAndCounty) => `${c.county}__${c.city}`;

export const useCityAndCountyOptions = (args?: Props) => {
  const dispatch = useAppDispatch();
  const status = useSelector(selectCitiesStatus);

  const options = useSelector((state) =>
    selectCityOptions(state, args?.groupByCounty),
  );

  // Fetch on mount if not loaded yet
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCitiesAndCounties());
    }
  }, [dispatch, status]);

  const cityAndCountyOptions = useMemo<CityAndCounty[]>(() => {
    if (!args?.allLabel) return options;
    // Prepend "All" option
    const all: CityAndCounty = { city: args.allLabel, county: "" };
    return [all, ...options];
  }, [args?.allLabel, options]);

  const isLoading = status === "pending";

  return { options: cityAndCountyOptions, isLoading, status };
};
